import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Search, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function PublicEventCheckIn() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [done, setDone] = useState(null);

  const load = useCallback(async () => {
    const r = await api.get(`/public/event-checkin/${token}`);
    setData(r.data);
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const doCheckIn = async (p) => {
    try {
      const r = await api.post(`/public/event-checkin/${token}`, { participant_id: p.participant_id });
      setDone({ name: r.data.name, already: r.data.already_checked_in });
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  if (!data) return <div className="min-h-screen flex items-center justify-center overline">Carregando…</div>;
  const brand = data.brand || {};
  const primary = brand.brand_primary || "#C07C88";
  const gold = brand.brand_accent || "#D4AF37";
  const filtered = data.participants.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));

  if (done) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
        <Card className="p-10 max-w-md w-full text-center border-border shadow-none">
          <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: `${gold}15` }}><CheckCircle2 size={36} className="text-emerald-600" /></div>
          <p className="overline mt-4 text-emerald-700">{done.already ? "Já registrado" : "Presença confirmada"}</p>
          <p className="font-heading text-3xl mt-3" style={{ color: primary }}>{done.name}</p>
          <p className="text-sm text-muted-foreground mt-2">Bem-vindo(a) ao {data.event.title}!</p>
          <Button className="mt-6" variant="outline" onClick={() => setDone(null)}>Fazer check-in de outro participante</Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="doc-paper p-8 md:p-10">
          <div className="text-center pb-6 border-b border-border">
            <p className="overline">Check-in do Evento</p>
            <h1 className="font-heading text-3xl mt-2" style={{ color: primary }}>{data.event.title}</h1>
            <p className="text-sm text-muted-foreground mt-2">{data.event.location}</p>
          </div>
          <div className="mt-6">
            <Label className="text-xs uppercase tracking-wider">Encontre seu nome</Label>
            <div className="relative mt-2">
              <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input placeholder="Buscar por nome" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="checkin-search" />
            </div>
            <div className="mt-4 divide-y divide-border max-h-96 overflow-auto border border-border rounded-md">
              {filtered.map((p) => (
                <button key={p.participant_id} disabled={p.checked_in} onClick={() => doCheckIn(p)} className="w-full text-left p-3 flex items-center justify-between hover:bg-[#FAFAFA] disabled:opacity-40" data-testid={`checkin-${p.participant_id}`}>
                  <div>
                    <p className="font-medium text-sm">{p.name}</p>
                    <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{p.category}</p>
                  </div>
                  {p.checked_in ? <span className="text-xs text-emerald-600">✓ Presente</span> : <span className="text-xs" style={{ color: primary }}>Confirmar →</span>}
                </button>
              ))}
              {filtered.length === 0 && <p className="text-xs text-muted-foreground p-6 text-center">Nenhum resultado</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
